/**
 * Aceptar invitación — público (FR-001).
 */
import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router'

import { Button } from '../components/ui/button'
import { Input } from '../components/ui/input'
import { api, ErrorApi } from '../lib/api'
import { LONGITUD_MINIMA_PASSWORD, passwordValida } from '../lib/password-policy'

export function AcceptInvite() {
    const [params] = useSearchParams()
    const token = params.get('token') ?? ''
    const navigate = useNavigate()
    const [password, setPassword] = useState('')
    const [error, setError] = useState<string | null>(null)
    const [ok, setOk] = useState(false)
    const [enviando, setEnviando] = useState(false)

    async function enviar(e: React.FormEvent) {
        e.preventDefault()
        setError(null)
        if (!token) {
            setError('Falta el enlace de invitación')
            return
        }
        if (!passwordValida(password)) {
            setError(`La contraseña debe tener al menos ${LONGITUD_MINIMA_PASSWORD} caracteres`)
            return
        }
        setEnviando(true)
        try {
            await api.post('/auth/accept-invite', { token, password })
            setOk(true)
            setTimeout(() => navigate('/login', { replace: true }), 800)
        } catch (err) {
            setError(err instanceof ErrorApi ? err.message : 'No se pudo aceptar la invitación')
        } finally {
            setEnviando(false)
        }
    }

    return (
        <div className="grid min-h-screen place-items-center bg-neutral-950 font-mono text-neutral-200">
            <form onSubmit={(e) => void enviar(e)} className="mx-4 w-full max-w-80 space-y-4 rounded-lg border border-neutral-800 p-6">
                <div>
                    <h1 className="text-sm font-semibold text-neutral-100">Aceptar invitación</h1>
                    <p className="mt-1 text-xs text-neutral-500">Elige tu contraseña (≥ {LONGITUD_MINIMA_PASSWORD})</p>
                </div>
                <Input
                    aria-label="Nueva contraseña"
                    type="password"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                {error && (
                    <p role="alert" className="text-xs text-red-400">
                        {error}
                    </p>
                )}
                {ok && <p className="text-xs text-emerald-400">Listo. Ve al login…</p>}
                <Button type="submit" className="min-h-11 w-full" disabled={enviando || !password}>
                    {enviando ? 'Guardando…' : 'Guardar contraseña'}
                </Button>
                <Link to="/login" className="block text-center text-xs text-neutral-500 hover:text-neutral-300">
                    Ir al login
                </Link>
            </form>
        </div>
    )
}
